<script lang="ts">
    import type { SequenceNode } from "./sequence";
    import type * as t from "./types";

    import StepHeader from "./components/StepHeader.svelte";
    import PaddingX from "./components/PaddingX.svelte";
    import { getAppContext } from "./quiz-store";

    export let visible: boolean;
    export let stepNode: SequenceNode<t.Step>;

    const ctx = getAppContext();

    function handleClickCard(title: string, cardIdx: number) {
        let nextStepNode: SequenceNode<t.ConstructMinigameStep> =
            stepNode.next as SequenceNode<t.ConstructMinigameStep>;
        if (
            nextStepNode == null ||
            nextStepNode.value.type !== "construct_minigame"
        ) {
            console.error(
                "[shpln-quiz] Next step must be construct_minigame, but it is ${stepNode.next?.value.type}",
            );
        }

        let iframeSrc: string;
        switch (cardIdx) {
            case 0:
                iframeSrc =
                    "https://shpln-quiz.s3.us-east-1.amazonaws.com/minigames/louis_vuitton/memory/index.html";
                break;
            case 1:
                iframeSrc =
                    "https://shpln-quiz.s3.us-east-1.amazonaws.com/minigames/central_perk/trivia/index.html";
                break;
            case 2:
                iframeSrc =
                    "https://shpln-quiz.s3.us-east-1.amazonaws.com/minigames/shake_shack/plinko/index.html";
                break;
        }

        // WARN: For demo purposes only, shouldn't be in production
        ctx.state.update(($) => {
            if ($.step.next?.value.type !== "construct_minigame") {
                return $;
            }
            $.step.next.value.state = {
                ...nextStepNode.value.state,
                title,
                iframeSrc,
            };
            return $;
        });

        ctx.actions.goToNextStep();
    }
</script>

<StepHeader title={"Play More"} subtitle={"Earn Higher Discounts"} />
<PaddingX class="mt-12 flex flex-col gap-4">
    <a
        class="card flex items-center gap-8 rounded-md p-4 transition-transform hover:scale-105"
        on:click={(e) => {
            e.preventDefault();
            handleClickCard("Louis Vuitton Memory", 0);
        }}
        href="/"
    >
        <div class="relative aspect-[1.2] h-20 rounded">
            <img
                src="https://shpln-quiz.s3.us-east-1.amazonaws.com/assets/network_portal_demo/louis_vuitton.png"
                alt=""
                class="absolute inset-0 size-full object-cover p-2"
            />
        </div>
        <div>
            Explore Louis Vuitton's Ski Collection and Earn More Discounts
        </div>
    </a>
    <a
        class="card flex items-center gap-8 rounded-md p-4 transition-transform hover:scale-105"
        on:click={(e) => {
            e.preventDefault();
            handleClickCard("Central Perk Cofee Trivia", 1);
        }}
        href="/"
    >
        <div class="relative aspect-[1.2] h-20 rounded">
            <img
                src="https://shpln-quiz.s3.us-east-1.amazonaws.com/assets/network_portal_demo/central_perk.webp"
                alt=""
                class="absolute inset-0 size-full object-cover p-2"
            />
        </div>
        <div>
            Play Central Perk Coffee's Friends Trivia and Earn More Discounts
        </div>
    </a>
    <a
        class="card flex items-center gap-8 rounded-md p-4 transition-transform hover:scale-105"
        on:click={(e) => {
            e.preventDefault();
            handleClickCard("Shake Shack Plinko", 2);
        }}
        href="/"
    >
        <div class="relative aspect-[1.2] h-20 rounded">
            <img
                src="https://shpln-quiz.s3.us-east-1.amazonaws.com/assets/network_portal_demo/shake_shack.jpeg"
                alt=""
                class="absolute inset-0 size-full object-cover p-2"
            />
        </div>
        <div>Play Shake Shack Plinko and Earn More Discounts</div>
    </a>
</PaddingX>

<style>
    .card {
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        cursor: pointer;
    }
</style>
